import { render, staticRenderFns } from "./EternityButton.vue?vue&type=template&id=159fbd96&scoped=true"
import script from "./EternityButton.vue?vue&type=script&lang=js"
export * from "./EternityButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159fbd96",
  null
  
)

export default component.exports